import { Lightbulb } from "lucide-react";
import type { CourseTreeNode } from "@/types/generated";
import type { CodeStoryboard } from "@/types/storyboard";
import { StoryboardFallback } from "@/components/storyboard/StoryboardFallback";
import { CodeExample } from "@/components/storyboard/text/CodeExample";
import { CodeTheory } from "@/components/storyboard/text/CodeTheory";
import { TextAnalogy } from "@/components/storyboard/text/TextAnalogy";
import { CodeQuestion } from "@/components/storyboard/text/CodeQuestion";

interface Props {
  data: CodeStoryboard;
  contentElement: CourseTreeNode;
}

export const StoryboardCodeRenderer = ({ data, contentElement }: Props) => {
  switch (data.subType) {
    case "CODE_EXAMPLE":
      return <CodeExample data={data.text} />;
    case "CODE_THEORY":
      return <CodeTheory data={data.text} />;
    case "CODE_ANALOGY":
      return <TextAnalogy text={data.text} />;
    case "CODE_QUESTION":
      return <CodeQuestion data={data.text} />;
    case "CODE_EXAMPLE_PROBLEMSOLVING":
      return (
        <CodeExample
          data={{ sections: data.text.sections }}
          icon={Lightbulb}
          title={data.text.title}
          numberSnippets={false}
        />
      );
    default:
      return <StoryboardFallback title={contentElement.title} />;
  }
};
